import Image from "next/image";
import { ArrowUpRight } from "lucide-react";
import Link from "next/link";
import PostCategoryBadge from "./post-category-badge";
import ImageFallback from "./image-fallback";
import type { PostCategoryT } from "@/app/types/posts";

export default function BlogCard({
  image,
  title,
  subtitle,
  link,
  categories,
  altText,
  categoriesClickable = true,
  consumptionText,
}: {
  image: string | null;
  title: string;
  subtitle: string;
  link: string;
  categories: PostCategoryT[] | string[];
  altText?: string;
  categoriesClickable?: boolean;
  consumptionText?: string;
}) {
  return (
    <div className="flex flex-col">
      {image ? (
        <Link href={link} className="block">
          <Image
            src={image}
            alt={altText || title || "Bild" || "Bild des Beitrags"}
            width={500}
            height={500}
            className="aspect-video w-full rounded-lg object-cover"
          />
        </Link>
      ) : (
        <Link href={link} className="block">
          <ImageFallback />
        </Link>
      )}
      <div className="flex flex-row gap-2 pt-4">
        {categories.map((category, index) => {
          if (typeof category === "string") {
            return (
              <span
                key={index}
                className="bg-secondary hover:bg-secondary/80 inline-block rounded-full px-3 py-1 text-xs transition-colors"
              >
                {category}
              </span>
            );
          }
          return (
            <PostCategoryBadge
              key={category.key}
              category={category}
              clickable={categoriesClickable}
            />
          );
        })}
      </div>
      <Link href={link} className="group">
        <h2 className="heading-small group-hover:text-primary flex flex-row items-center gap-2 pt-2 transition-colors">
          {title}
          <span className="inline-block">
            <ArrowUpRight className="size-5" />
          </span>
        </h2>
        <p className="text-muted-foreground line-clamp-2 pt-1 font-normal">
          {subtitle}
        </p>
        <p className="text-muted-foreground mt-2 text-xs">{consumptionText}</p>
      </Link>
    </div>
  );
}
